import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import { IconComponent } from '../../../core/components/icon/icon.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatInput, MatError } from '@angular/material/input';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';

@Component({
  selector: 'app-notify-me-dialog',
  templateUrl: './notify-me-dialog.component.html',
  styleUrls: ['./notify-me-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconComponent,
    MatDialogClose,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatError,
    FromDictionaryPipe,
  ],
})
export class NotifyMeDialogComponent {
  dialogRef = inject<MatDialogRef<NotifyMeDialogComponent>>(MatDialogRef);
  data = inject<{
    prefix: string;
    email?: string | null;
    [key: string]: any;
  }>(MAT_DIALOG_DATA);

  fb = inject(FormBuilder);
  klaviyoEmailForm = this.fb.group(
    {
      email: ['', [Validators.required, Validators.email]],
    },
    { updateOn: 'submit' }
  );

  constructor() {
    const data = this.data;

    if (data.email) {
      this.klaviyoEmailForm.patchValue({ email: data.email });
    }
  }
  closeDialog(): void {
    this.dialogRef.close('TODO');
  }

  submit() {
    if (this.klaviyoEmailForm.valid) {
      this.dialogRef.close(this.klaviyoEmailForm?.value?.email);
    }
  }
}
